import React, { Component } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@material-ui/core/Dialog";
// import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import { GetQRCode_Url } from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
class PreviewDialog extends Component {
  header = store.getState().header.header;
  tollfreeNumber = store.getState().appUserData.tollfreeNumber;

  constructor(props) {
    super(props);
    this.state = {
      qrcodeimg: "",
      keyword: "",
      messageName: "",
      initialPage: 0,
      pageSize: 10,
      activityList: [],
      open: false,
    };
  }

  showQRCode(rowData) {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: rowData.id,
      },
    };
    FetchServerData.callPostService(GetQRCode_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          window.scrollTo(0, 0);
          let qrcodeimg = output.data.qrCode;
          this.setState({
            qrcodeimg: qrcodeimg,
            keyword: rowData?.keyword,
            messageName: rowData?.messagename,
            open: true,
          });
        } else {
        }
      }
    );
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  render() {
    return (
      <>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          maxWidth="xl"
          className="QRCodeDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>
              Preview message using keyword/QR code
            </span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent>
            <div
              className="row d-flex"
              style={{
                width: "100%",
                color: "#000",
                fontSize: "small",
                padding: "2em 1em",
              }}
            >
              <div className="col-sm-7">
                <div className="row text-center">
                  <div
                    className="col-sm-12"
                    style={{
                      textAlign: "left",
                    }}
                  >
                    <div className="row mt-2">
                      <p style={{ fontSize: "16px" }}>
                        Opt-in messages like this cannot be sent -- <br></br> they can only be accessed via its keyword or widget.

                      </p>
                      <p style={{ fontSize: "16px" }}>
                        To preview this message, text {" "}
                        <spna className="fw-bold">{`"${this.state.keyword}"`}</spna>{" "}
                        to{" "}
                        {this.tollfreeNumber !== null &&
                          Utils.viewTollFreeNumberFormate(
                            this.tollfreeNumber
                          ).slice(-12)}{" "}
                        or shoot the QR Code then tap SEND once the keyword loads into your texting app.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-5">
                <div className="row" style={{ paddingTop: "10px" }}>
                  <img
                    src={`data:image/png;base64,${this.state.qrcodeimg}`}
                    alt=""
                    style={{
                      maxHeight: "280px",
                      // width: "280px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
export default PreviewDialog;
